import type { Link } from '@wix/editor-react-types';

export const CLICK_ANALYTICS_SRC = 76;
export const CLICK_ANALYTICS_EVID = 1113;
export const CLICK_ANALYTICS_ENDPOINT = 'pa';

export const ClickAnalyticsGroups = {
  Text: 'Text',
  Menu: 'Menu',
  Image: 'Image',
  Input: 'Input',
  Login: 'Login',
  Button: 'Button',
  Social: 'Social',
  Gallery: 'Gallery',
  Community: 'Community',
  Decorative: 'Decorative',
  MenuAndSearch: 'MenuAndSearch',
  MenuAndAnchor: 'MenuAndAnchor',
} as const;

export type ClickAnalyticsGroup =
  (typeof ClickAnalyticsGroups)[keyof typeof ClickAnalyticsGroups];

export type ClickAnalyticsParams = {
  elementId?: string;
  elementType: string;
  elementGroup: ClickAnalyticsGroup;
  elementTitle?: string;
  language?: string;
  link?: Link;
  details?: Record<string, unknown>;
};

export type ClickAnalyticsEvent = {
  src: number;
  evid: number;
  bl: string;
  url: string;
  element_id?: string;
  elementType: string;
  elementGroup: ClickAnalyticsGroup;
  elementTitle?: string;
  language?: string;
  actionName?: string;
  value?: string;
  details?: string;
};

export const buildClickAnalyticsEvent = ({
  link,
  details,
  elementId,
  elementType,
  elementGroup,
  elementTitle,
  language,
}: ClickAnalyticsParams): ClickAnalyticsEvent => ({
  src: CLICK_ANALYTICS_SRC,
  evid: CLICK_ANALYTICS_EVID,
  bl: navigator.language,
  url: window.location.href,
  element_id: elementId,
  elementType,
  elementGroup,
  elementTitle,
  language,
  value: link?.href,
  details: details ? JSON.stringify(details) : undefined,
});
